import { Card, Divider, Typography } from '@healthinal/ui';
import { SocialAnamnesisDto } from '../../../../../api/generated/model';
import { EditSocialAnamnesisForm } from './EditSocialAnamnesisForm.tsx';

export function SocialAnamnesisCard({
  social,
  patientId,
  anamnesisId,
  selectedAnamnesisType,
}: {
  social: SocialAnamnesisDto;
  patientId: string;
  anamnesisId: string;
  selectedAnamnesisType: string;
}) {
  return (
    <Card>
      <Typography level="title-lg">Sozialanamnese</Typography>
      <Divider />
      <EditSocialAnamnesisForm
        key={anamnesisId}
        socialAnamnesis={social}
        patientId={patientId}
        anamnesisId={anamnesisId}
        selectedAnamnesisType={selectedAnamnesisType}
      />
    </Card>
  );
}
